import {sweetAPI} from 'app/store/sweet-api';
import {providesTagsByURL, showMessages} from 'app/store/sweet-api/utils';
import {PERMISSIONS_API_URL} from 'app/urls';
import {gt} from 'app/utils/i18n';
import {PERMISSIONS_RTK_TAGS} from 'app/utils/rtk-tags';

import type {
  GroupObjectPermissionType,
  ObjectPermissionsParamsType,
} from './types';
import type {ListResponseType} from 'sweet-types';

export const extendedAPI = sweetAPI
  .enhanceEndpoints({addTagTypes: [PERMISSIONS_RTK_TAGS.TAGS]})
  .injectEndpoints({
    endpoints: (build) => ({
      getObjectPermissions: build.query<
        ListResponseType<GroupObjectPermissionType>,
        ObjectPermissionsParamsType
      >({
        query: (params) => ({
          url: PERMISSIONS_API_URL,
          params,
        }),
        onQueryStarted: showMessages({
          onError: () => gt("Couldn't load permissions"),
        }),
        providesTags: providesTagsByURL(PERMISSIONS_RTK_TAGS.TAGS),
      }),
    }),
  });

export const {useGetObjectPermissionsQuery: useObjectPermissions} = extendedAPI;
